import "core-js/modules/es.error.cause.js";
// 密码规则校验
export const passwordRulesValidation = function (rule, value, callback) {
  if (!value) {
    callback(new Error($t("c2r1q94", "密码必填")));
  } else {
    //数字字母组合
    let reg1 = /^.{8,}$/;
    // /^(?!^[0-9a-z]+$)(?!^[0-9A-Z]+$)(?!^[0-9\x21-\x2f\x3a-\x40\x5b-\x60\x7B-\x7F]+$)(?!^[a-zA-Z]+$)(?!^[a-z\x21-\x2f\x3a-\x40\x5b-\x60\x7B-\x7F]+$)(?!^[A-Z\x21-\x2f\x3a-\x40\x5b-\x60\x7B-\x7F]+$)(?!^[A-Z\x21-\x2f\x3a-\x40\x5b-\x60\x7B-\x7F]+$)[a-z0-9A-Z\x21-\x2f\x3a-\x40\x5b-\x60\x7B-\x7F]{8,20}$/;
    // //数字特殊字符组合
    // let reg2 = /^(?=.*\d)(?=.*[!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]).{6,20}$/;
    // //字母特殊字符组合
    // let reg3 =
    //   /^(?=.*[a-zA-Z])(?=.*[!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]).{6,20}$/;
    // //大写字母小写字母组合
    // let reg4 = /^(?=.*[a-z])(?=.*[A-Z]).{6,20}$/;
    if (reg1.test(value)) {
      callback();
    } else {
      callback(new Error($t("ok26h3g", "密码不符合规则，请确认后重新输入")));
    }
  }
};

/*
 * 判断网址上是否有  ?protocol=SAML, 如果有, 接口调取
 */
export const samlOpen = function () {
  window.open(location.origin + "/api/sso/samlAuth", "_self");
};